module.exports = __webpack_public_path__ + "static/media/add-file.ee606902.svg";